import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => {
  const colorSacola =
    theme.palette.type === 'light'
      ? theme.palette.text.primary
      : theme.palette.text.primary;

  const colorDisabled = theme.palette.text.disabled;
  return {
    root: {
      cursor: 'pointer',
      position: 'relative',
      marginBottom: theme.spacing(2)
    },
    divider: {
      background: 'none',
      borderTop: `1px dashed ${colorDisabled}`,
      marginTop: theme.spacing(2),
    },
    dividerTop: {
      margin: theme.spacing(0, -2),
      marginBottom: theme.spacing(1)
    },
    colorSacola: {
      color: colorSacola
    },
    titulo: {
      fontWeight: 500,
    },
    icon: {
      fill: colorSacola
    },
    endereco: {
      color: theme.palette.type === 'light' ? theme.palette.grey[600] : theme.palette.grey[400],
      fontWeight: 500,
      fontSize: 13
    }
  }
});